import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  CheckoutRootParamList,
  CheckoutCreateSaleQuoteRootScreenParamList,
} from "../../../../types";
import { useSaleControllerProvider } from "../../utils/sale-controller";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { CompleteQuoteScreen } from "../CompleteQuoteScreen";
import { CreateQuoteRootScreenContext } from "./context";
import { AcceptedQuoteDepositRootScreen } from "../AcceptedQuoteDepositRootScreen";

export type CreateSaleQuoteRootScreenProps = NativeStackScreenProps<
  CheckoutRootParamList,
  "CreateSaleQuoteRootScreen"
>;

export const CreateSaleQuoteRootScreen =
  ({}: CreateSaleQuoteRootScreenProps) => {
    const { sale } = useSaleControllerProvider();

    const Stack =
      createStackHeaderNavigator<CheckoutCreateSaleQuoteRootScreenParamList>();

    if (!sale) {
      return null;
    }

    return (
      <CreateQuoteRootScreenContext.Provider value={{ sale }}>
        <Stack.Navigator
          screenOptions={{
            animationEnabled: true,
            title: ``,
          }}
        >
          <Stack.Group
            screenOptions={{
              headerLeft: () => <ModalCloseButton type="Cancel" />,
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            }}
          >
            <Stack.Screen
              name="CompleteQuoteScreen"
              component={CompleteQuoteScreen}
            />
          </Stack.Group>
          <Stack.Group
            screenOptions={{
              headerShown: false,
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            }}
          >
            <Stack.Screen
              name="AcceptedQuoteDepositRootScreen"
              component={AcceptedQuoteDepositRootScreen}
            />
          </Stack.Group>
        </Stack.Navigator>
      </CreateQuoteRootScreenContext.Provider>
    );
  };
